import React, { useContext } from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import StoreContext from '~/context/StoreContext'
import {
  Grid,
  Product,
  Title,
  PriceTag
} from './styles'
import { Img } from '~/utils/styles';
import { useIntl, Link, FormattedMessage } from "gatsby-plugin-intl";

const currencyMapper = {
  "price_uk":"£",
  "price_sek":"SEK",
  "price_eu":"€"
}

const ProductGrid = () => {
  const { store: {checkout}} = useContext(StoreContext)
  const { allShopifyProduct } = useStaticQuery(
    graphql`
      query {
        allShopifyProduct(
          sort: {
            fields: [createdAt]
            order: DESC
          }
        ) {
          edges {
            node {
              id
              title
              handle
              createdAt
              metafields {
                key
                value
              }
              images {
                id
                originalSrc
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 910) {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                  }
                }
              }
              variants {
                price
              }
            }
          }
        }
      }
    `
  )

  const intl = useIntl();

  const getPrice = price => Intl.NumberFormat(undefined, {
    currency: checkout.currencyCode ? checkout.currencyCode : 'EUR',
    minimumFractionDigits: 2,
    style: 'currency',
  }).format(parseFloat(price ? price : 0))


  return (
    <Grid>
      {allShopifyProduct.edges
        ? allShopifyProduct.edges.map(
          ({ node: { id, handle, title, images: [firstImage], variants: [firstVariant],metafields } }) => {

          const currency = intl.formatMessage({ id: "price_key" })
          const metaPrice = metafields.filter( item => item.key === currency)[0]
         return ( <Product key={id} >
            <Link to={`/product/${handle}/`}>
              {firstImage && firstImage.localFile &&
                (<Img
                  fluid={firstImage.localFile.childImageSharp.fluid}
                  alt={handle}
                />)}
            </Link>
            <Title>{title}</Title>
            {/* <PriceTag>{getPrice(firstVariant.price)}</PriceTag> */}
            <PriceTag>{currencyMapper[currency] + metaPrice.value}</PriceTag>
            
          </Product>
        )})
        : <p>No Products found!</p>}
    </Grid>
  )
}

export default ProductGrid
